import { combineReducers } from 'redux';
import { user } from './redux/user';
import { menu } from './redux/menu';
import { modalDetail } from './redux/modal/build-modal-detail';

// 公告管理 - 公告编辑
import { publicNotices } from './redux/public/notices';
import { publicSystemNotices } from './redux/public/systemNotice';

// 帮助手册管理 - 公告编辑
import { publicHelpManual } from './redux/public/helpManual';
// 系统管理->菜单管理
import { MenuManagement } from './redux/system/menuManagement';
// 帮助手册管理 - 公告发送
import { publicHelpManualSend } from './redux/public/helpManualSend';
import { publicBannerUp } from './redux/public/bannerUp';
import { publicTestAction } from './redux/public/testAction';
import { publicMessage } from './redux/public/message';
import { publicCompanyMessage } from './redux/public/companyMessage';
// 消息管理->短信推送
import { publicAboutus } from './redux/public/aboutus';
import { systemRole } from './redux/system/role';
import { systemMenu } from './redux/system/menu';
import { systemSysParam } from './redux/system/sysParam';
import { systemUpdate } from './redux/system/update';
import { systemStrategy } from './redux/system/strategy';
import { systemUser } from './redux/system/user';
import { systemPwdReset } from './redux/system/pwdReset';
import { systemLog } from './redux/system/log';
// 数据字典管理
import { DataDict } from './redux/system/dataDict';
// 文章管理/组别管理
import { systemArticleClass } from './redux/system/articleClass';
// 文章管理-客服管理
import { customerService } from './redux/system/customerService';
// 文章管理 banner管理
import { publicBanner } from './redux/public/banner';
// 业务管理
// 会员管理-会员查询
import { bizUserUser } from '@redux/biz/user/user/user';
import { bizUserUserCloseList } from '@redux/biz/user/user/user-closeList';
import { bizUserUserAddress } from '@redux/biz/user/user/user-address';
// 业务管理-资产转移记录
import { bizUserTransferRecord } from '@redux/biz/user/user/transferRecord';
import { bizUserTransferRecordDetail } from '@redux/biz/user/user/transferRecordDetail';
// 发行方用户查询
import { bizUserPlatUser } from '@redux/biz/user/platUser/platUser';
// kyc审核
import { bizUserKycCheck } from './redux/biz/user/kycCheck/kycCheck';
// 激活码管理
import { bizActiveCodeActivityCode } from '@redux/biz/user/activityCode/activityCode.js';
// 会员管理-游离会员
import { bizFreeUser } from './redux/biz/user/freeUser/freeUser';
// 会员管理-会员等级
import { bizUserLevel } from './redux/biz/user/level/level';
// 会员管理-会员等级规则
import { bizUserLevelRules } from './redux/biz/user/levelRules/levelRules';
// 会员管理-钻石赠送规则
import { bizUserDiamondRules } from './redux/biz/user/diamondRules/diamondRules';
// 财务管理
// 会员资产
import { financeMemberAccount } from './redux/finance/member/account';
import { financeMemberAccountBalance } from './redux/finance/member/accountBalance';
import { financeMemberAccountDiamond } from './redux/finance/member/accountDiamond';
import { financeMemberAccountIntegral } from './redux/finance/member/accountIntegral';
import { financeMemberAccountEssence } from './redux/finance/member/accountEssence';
import { financeMemberAccountBill } from './redux/finance/member/account-bill';
import { financeMemberAccountYao } from './redux/finance/member/accountYao';
// 提现管理
import { financeWithdrawalApproval } from './redux/finance/withdrawal/approval';
import { financeWithdrawalRecord } from './redux/finance/withdrawal/record';
import { financeWithdrawalRecordExportPaymentBill } from './redux/finance/withdrawal/record-exportPaymentBill';
import { financeWithdrawalCompleted } from './redux/finance/withdrawal/completed';
import { financeWithdrawalNopass } from './redux/finance/withdrawal/nopass';
import { financeWithdrawalRejected } from './redux/finance/withdrawal/rejected';
import { financeWithdrawalRelus } from './redux/finance/withdrawal/rules';
import { financeWithdrawalPayFail } from '@redux/finance/withdrawal/payFail';
import { financeWithdrawalPaying } from '@redux/finance/withdrawal/paying';
import { financeWithdrawalInitiating } from '@redux/finance/withdrawal/initiating';

// 充币管理
import { financeRechargeQuery } from './redux/finance/recharge/query';
import { financeRechargeGJQuery } from './redux/finance/recharge/gjquery';
// 转账管理
import { financeTransferApproval } from './redux/finance/transfer/approval';
import { financeTransferCompleted } from './redux/finance/transfer/completed';
import { financeTransferNopass } from './redux/finance/transfer/nopass';
import { financeTransferRules } from './redux/finance/transfer/rules';

// 业务管理-推荐分佣
import { bizIncomeTeam } from '@redux/biz/income/team';
import { bizIncomeRules } from '@redux/biz/income/rules';

// 业务管理-推荐分佣-每日分佣分布
import { bizIncomeDailyUser } from '@redux/biz/income/dailyUser';

// 业务管理-推荐分佣-每日社区查询
import { bizIncomeIncome } from './redux/biz/income/income';

// 业务管理-推荐分佣-分成规则
import { bizIncomeConfig } from './redux/biz/income/config';

// 出纳管理-持币快照
import { financeMemberAccountSnapshot } from './redux/finance/member/accountSnapshot';

// 版本日志管理
import { systemVersionLog } from './redux/system/versionLog';

// 统计分析
import { statisticsDailyReport } from './redux/statistics/dailyReport';

// 业务管理--评论管理
import { bizCommentKeywords } from './redux/biz/comment/keywords';
import { bizCommentCheck } from './redux/biz/comment/check';
import { bizCommentList } from './redux/biz/comment/list';
import { bizCommentReport } from './redux/biz/comment/report';

// 业务管理-帖子管理
import { bizPostList } from './redux/biz/post/list';
import { bizPostReport } from './redux/biz/post/report';

// NFT管理-时刻管理
import { NFTCollectionCollection } from './redux/NFT/collection/collection';
import { NFTCollectionModelList } from './redux/NFT/collection/model-list';
import { NFTCollectionModel } from './redux/NFT/collection/model';
import { NFTCollectionModelRecovery } from './redux/NFT/collection/modelRecovery';
import { NFTCollectionModelCirculatio } from './redux/NFT/collection/circulatioRrecord';
import { NFTCollectionCategory } from './redux/NFT/collection/category';
import { NFTCollectionConfig } from './redux/NFT/collection/config';
import { NFTCollectionTransferRecord } from './redux/NFT/collection/transferRecord';
import { NFTCollectionTransferRecordCollection } from './redux/NFT/collection/transferRecordCollection';

import { NFTOrderWorkConfig } from './redux/NFT/order/workConfig';
import { NFTOrderPfpConfig } from './redux/NFT/order/pfpConfig';

// NFT管理-出售管理
import { NFTOrderBidding } from './redux/NFT/order/bidding';
import { NFTOrderBiddingRecord } from './redux/NFT/order/bidding-record';
import { NFTOrderBiddingDelayRecord } from './redux/NFT/order/bidding-delayRecord';
import { NFTOrderBiddingBondRecord } from './redux/NFT/order/bidding-bondRecord';
import { NFTOrderBiddingConfig } from './redux/NFT/order/bidding-config';
import { NFTOrderBuyoutPrice } from './redux/NFT/order/buyoutPrice';
import { NFTOrderBuyoutPriceOrder } from './redux/NFT/order/buyoutPrice-order';
import { NFTOrderBuyoutPriceConfig } from './redux/NFT/order/buyoutPrice-config';
import { NFTOrderCollectionPack } from './redux/NFT/order/collectionPack';
import { NFTOrderCollectionPackOrder } from './redux/NFT/order/collectionPack-order';
import { NFTOrderCategory } from './redux/NFT/order/category';

import { NFTOrderHistoryBidding } from './redux/NFT/order/historyBidding';
import { NFTOrderHistoryBuyoutPrice } from './redux/NFT/order/historyBuyoutPrice';
import { NFTOrderHistoryBuyoutPriceOrder } from './redux/NFT/order/historyBuyoutPrice-order';

// NFT管理-挑战管理
import { NFTChallengeList } from './redux/NFT/challenge/list';
import { NFTChallengeInProgress } from '@redux/NFT/challenge/inProgress';
import { NFTChallengeAwardProvide } from '@redux/NFT/challenge/awardProvide';
import { NFTChallengeComponentCollection } from '@redux/NFT/challenge/component/collection';
import { NFTChallengeComponentAwardWinningRecord } from '@redux/NFT/challenge/component/awardWinningRecord';
import { NFTChallengeFail } from '@redux/NFT/challenge/fail';
import { NFTChallengeHistory } from '@redux/NFT/challenge/history';
import { NFTChallengeChallenge } from '@redux/NFT/challenge/challenge';
import { NFTChallengeChallengeCondition } from '@redux/NFT/challenge/challengeCondition';
import { NFTChallengeOrderNFT } from '@redux/NFT/challenge/orderNFT';
import { NFTChallengeOrderReal } from '@redux/NFT/challenge/orderReal';
import { NFTChallengeCategory } from '@redux/NFT/challenge/category';

import { publicDetailList } from '@redux/public/publicDetailList';

// NFT管理-导出管理
import { NFTExportList } from './redux/NFT/export/export';
import { NFTExportListDetail } from './redux/NFT/export/exportDetail';
import { NFTExportBlockChainAddressM } from './redux/NFT/export/blockChainAddressM';
import { NFTExportBeOnTheAir } from './redux/NFT/export/beOnTheAir';
import { NFTExportToBeBroadcast } from './redux/NFT/export/toBeBroadcast';
import { NFTExportNopass } from './redux/NFT/export/nopass';
import { NFTExportSuccess } from './redux/NFT/export/success';
import { NFTExportFail } from './redux/NFT/export/fail';

// NFT管理-铸币管理
import { NFTContractTokenList } from './redux/NFT/contractToken/contractToken';
import { NFTContractTokenBlockChainAddressS } from './redux/NFT/contractToken/blockChainAddressS';
import { NFTContractTokenBlockChainAddressW } from './redux/NFT/contractToken/blockChainAddressW';

// NFT管理-导出管理
import { NFTImportList } from './redux/NFT/import/import';
import { NFTImportAddress } from './redux/NFT/import/address';

// NFT管理-关注管理
import { NFTFollowCollection } from './redux/NFT/follow/collection';
import { NFTFollowCollectionPack } from './redux/NFT/follow/collectionPack';

// 时刻管理-百变大咖
import { NFTChangeSeries } from './redux/NFT/change/series';
import { NFTChangeType } from './redux/NFT/change/type';
import { NFTChangeModule } from './redux/NFT/change/module';
import { NFTChangeRecommendModule } from './redux/NFT/change/recommendModule';
import { NFTChangeConfig } from './redux/NFT/change/config';
import { NFTChangeBuyOrder } from './redux/NFT/change/buyOrder';
import { NFTChangeModifyRecord } from './redux/NFT/change/modifyRecord';

// 时刻管理-百变大咖
import { NFTBlindBoxBlindBoxModule } from './redux/NFT/blindBox/blindBoxModule';
import { NFTBlindBoxBlindKnapsack } from './redux/NFT/blindBox/knapsack';
import { NFTBlindBoxConfig } from './redux/NFT/blindBox/config';
import { NFTBlindBoxSeries } from './redux/NFT/blindBox/series';
import { NFTBlindBoxBuyOrder } from './redux/NFT/blindBox/buyOrder';

// 业务管理-宝藏计划
import { bizTreasurePlan } from './redux/biz/treasurePlan/treasurePlan';
import { bizTreasurePlanDetail } from './redux/biz/treasurePlan/treasurePlanDetail';

// 时刻管理-资产销售
import { NFTCollectionWorks } from './redux/NFT/collection/works';
import { NFTCollectionWorksPFP } from './redux/NFT/collection/worksPFP';
import { NFTCollectionNoSale } from './redux/NFT/collection/noSale';
import { NFTCollectionWorksDropRecord } from './redux/NFT/collection/worksDropRecord';
import { NFTCollectionWorksDistribution } from './redux/NFT/collection/worksDistribution';
import { NFTCollectionCopyrightSale } from '@redux/NFT/collection/copyrightSale';
import { NFTCollectionCopyrightUser } from '@redux/NFT/collection/copyrightUser';
import { NFTCollectionBuyOrder } from './redux/NFT/collection/buyOrder';
import { NFTCollectionDerivativeSale } from '@redux/NFT/collection/derivativeSale';
import { NFTCollectionAuthor } from '@redux/NFT/collection/author';
import { NFTCollectionAuthorEditRecord } from '@redux/NFT/collection/authorEditRecord';
import { NFTCollectionAuthorCollection } from '@redux/NFT/collection/authorCollection';
import { NFTCollectionAuthorChannel } from '@redux/NFT/collection/authorChannel';
import { NFTCollectionAuthorLoginConfig } from '@redux/NFT/collection/authorLoginConfig';
import { NFTCollectionEntity } from '@redux/NFT/collection/entity';
import { NFTCollectionBlindBoxSale } from '@redux/NFT/collection/blindBoxSale';
import { NFTCollectionLuckDrawSale } from '@redux/NFT/collection/luckDrawSale';
import { NFTCollectionLuckDrawSaleJoinRecord } from '@redux/NFT/collection/luckDrawSaleJoinRecord';
import { NFTCollectionSetWord } from '@redux/NFT/collection/setWord';
import { NFTCollectionPfpPeriodSale } from '@redux/NFT/collection/pfpPeriodSale';

// 会员管理-渠道商管理
import { bizUserChannelStore } from '@redux/biz/user/channelStore/channelStore';

// 会员管理-渠道管理
import { bizUserChannelConfig } from '@redux/biz/user/channelConfig/channelConfig';

// 会员管理-推荐设置
import { bizUserInviteConfig } from '@redux/biz/user/inviteConfig/inviteConfig';

// 会员管理-推荐分成
import { bizUserIncomeRefer } from '@redux/biz/user/incomeRefer/incomeRefer';

// 机构管理-兑换码管理
import { NFTCollectionExchangeCode } from '@redux/NFT/collection/exchangeCode';

// 机构管理-兑换码管理
import { NFTCollectionExchangeCodePeriod } from '@redux/NFT/collection/exchangeCodePeriod';

// 机构管理-合约管理
import { NFTCollectionContract } from '@redux/NFT/collection/contract';

// 活动管理-活动管理
import { NFTActivityActivity } from '@redux/NFT/activity/activity';
import { NFTActivityCard } from '@redux/NFT/activity/card';
import { NFTActivityLotteryRecord } from '@redux/NFT/activity/lotteryRecord';
import { NFTActivityPrize } from '@redux/NFT/activity/prize';
import { NFTActivitySynthesisRecord } from '@redux/NFT/activity/synthesisRecord';
import { NFTActivityRanking } from '@redux/NFT/activity/ranking';

// 统计分析-每日数据
import { statisticsTradeDataDay } from '@redux/statistics/tradeDataDay';

// 运维数据-业务支付渠道管理
import { systemBusinessChannel } from '@redux/system/businessChannel';

// 财务管理-银行管理
import { financeBankInfo } from '@redux/finance/bankInfo/bankInfo';

// 财务管理-三方支付
import { financeBankChannel } from '@redux/finance/payment/bankChannel';
import { financeUserBindCard } from '@redux/finance/payment/userBindCard';

// 三方系统
import { bizChannelSystem } from '@redux/biz/channelSys/channelSystem';
import { bizChannelTransferOrder } from '@redux/biz/channelSys/channelTransferOrder';
import { bizChannelTransferCollection } from '@redux/biz/channelSys/channelTransferCollection';
import { bizChannelSysSynchronize } from '@redux/biz/channelSys/synchronize';
import { bizChannelSysXmeta } from '@redux/biz/channelSys/Xmeta';
import { bizChannelSysXmetaOrder } from '@redux/biz/channelSys/XmetaOrder';
import { bizChannelSysXmetaExchange } from '@redux/biz/channelSys/XmetaExchange';

// 竞拍管理
import { NFTCollectionAuction } from '@redux/NFT/collection/auction/auction';
import { NFTCollectionAuctionRecord } from './redux/NFT/collection/auction/auction-record';
import { NFTCollectionAuctionDelayRecord } from './redux/NFT/collection/auction/auction-delayRecord';
import { NFTCollectionAuctionBondRecord } from './redux/NFT/collection/auction/auction-bondRecord';

// 统计分析-实时余额-排除用户清单
import { statisticsExcludeUserRecord } from '@redux/statistics/excludeUserRecord';

// 拉新活动
import { InvitationActivity } from '@redux/NFT/invitation/activity';
import { InvitationActivitySeries } from '@redux/NFT/invitation/activitySeries';
import { InvitationActivityUserRecord } from '@redux/NFT/invitation/activityUserRecord';
import { InvitationActivitySum } from '@redux/NFT/invitation/activityUserSum';

// 统计分析-每日资产统计
import { statisticsCollection } from '@redux/statistics/collection';

// 财务管理-三方结算管理
import { settlementApply } from '@redux/finance/settlement/apply';
import { settlementAccount } from '@redux/finance/settlement/account';
import { settlementAccountSettlementRecord } from '@redux/finance/settlement/settlementRecord';
import { settlementAccountJour } from '@redux/finance/settlement/jour';

// 赋能商城
import { goodsCategory } from '@redux/goods/category';
import { goodsClass } from '@redux/goods/class';
import { goodsSupplier } from '@redux/goods/supplier';
import { goodsIntegral } from '@redux/goods/integral';
import { goodsIntegralAdditional } from '@redux/goods/integralAdditional';
import { goodsBuyRecord } from '@redux/goods/buyRecord';
import { goodsExchangeRecord } from '@redux/goods/exchangeRecord';
import { goodsExchangeRecordDetail } from '@redux/goods/exchangeRecordDetail';
import { goodsJoinRecord } from '@redux/goods/joinRecord';
import { goodsActivityFinishRecord } from '@redux/goods/activityFinishRecord';
import { goodsActivity } from '@redux/goods/activity';

// 统计分析-元气超市统计
import { statisticsGoods } from '@redux/statistics/goods';

// 元宇宙管理-兑换管理
import { metaversePit } from '@redux/metaverse/exchange/pit';
import { metaversePitSeller } from '@redux/metaverse/exchange/pitSeller';
import { metaversePitConditionsDetail } from '@redux/metaverse/exchange/pitConditionsDetail';
import { metaverseJoinRecord } from '@redux/metaverse/exchange/joinRecord';
import { metaverseJoinRecordCollection } from '@redux/metaverse/exchange/joinRecordCollection';

// 实名配置
import { bizUserIdentifyConfig } from '@redux/biz/user/identifyConfig/identifyConfig';

// 公告弹窗
import { publicNoticesWindow } from '@redux/public/noticeWindow';

// 权益中心-降拍管理
import { rightInterestCategory } from '@redux/rightInterest/category';
import { rightInterestAuction } from '@redux/rightInterest/auction';
import { rightInterestBidRecord } from '@redux/rightInterest/bidRecord';
import { rightInterestAuctionOrder } from '@redux/rightInterest/auctionOrder';
import { rightInterestChangeRecord } from '@redux/rightInterest/changeRecord';
import { rightInterestBondRecord } from '@redux/rightInterest/bondRecord';

// 营销管理-抽奖活动
import { marketingLotteryActivity } from '@redux/marketing/lottery/activity';
import { marketingLotteryJoinOrder } from '@redux/marketing/lottery/joinOrder';
import { marketingLotteryJoinRecord } from '@redux/marketing/lottery/joinRecord';
import { marketingLotteryJoinDetail } from '@redux/marketing/lottery/joinDetail';

// 业务管理-渠道商管理
import { bizChannelMerchant } from '@redux/biz/channel/merchant';

// 业务管理-机构管理-出品方管理
import { NFTCollectionProduced } from '@redux/NFT/collection/produced';

// 财务管理-发行方结算账户
import { financeCompany } from '@redux/finance/company/company';
import { financeCompanySettleRecord } from '@redux/finance/company/settleRecord';

// 业务管理-机构管理-权益管理
import { NFTCollectionRightsManage } from '@redux/NFT/collection/rightsManage/rightsManage';
import { NFTCollectionRightsManageUseRecord } from '@redux/NFT/collection/rightsManage/useRecord';
import { NFTCollectionRightsManageAuthorRecord } from '@redux/NFT/collection/rightsManage/authorRecord';

// 财务管理-开票管理-开票管理
import { financeApplyInvoice } from '@redux/finance/applyInvoice/applyInvoice';

// 营销管理-芯片资产
import { marketingChipActivity } from '@redux/marketing/chip/activity';
import { marketingChipCollectionRecord } from '@redux/marketing/chip/collectionRecord';
import { marketingChipUid } from '@redux/marketing/chip/uid';

// 元宇宙管理-机器人管理
import { metaverseRobotConfig } from '@redux/metaverse/robot/config';
import { metaverseRobotAward } from '@redux/metaverse/robot/award';
import { metaverseRobotCalculationRrecord } from '@redux/metaverse/robot/calculationRrecord';
import { metaverseRobotWorkRecord } from '@redux/metaverse/robot/workRecord';
import { metaverseRobotWorkRobotRecord } from '@redux/metaverse/robot/workRobotRecord';
import { metaverseRobotSysParam } from '@redux/metaverse/robot/sysParam';

// 期数审核
import { periodCheckSellModifyCollectionList } from '@redux/NFT/collection/periodCheck/sellModifyCollectionList';
import { periodCheckWordList } from '@redux/NFT/collection/periodCheck/wordList';
import { periodCheckDropList } from '@redux/NFT/collection/periodCheck/dropList';
import { periodCheckPriorityList } from '@redux/NFT/collection/periodCheck/priorityList';
import { periodCheckDiscountList } from '@redux/NFT/collection/periodCheck/discountList';

// 系统管理-首页管理
import { systemHomeBanner } from '@redux/system/home/banner';
import { systemHomeFunction } from '@redux/system/home/function';
import { systemHomePlateCategory } from '@redux/system/home/plateCategory';
import { systemHomeMyPageBtn } from '@redux/system/home/myPageBtn';
import { systemHomeBalancePageBtn } from '@redux/system/home/balancePageBtn';

// 元宇宙管理-售卖管理
import { metaverseSaleDerivative } from '@redux/metaverse/sale/derivative';
import { metaverseSalePit } from '@redux/metaverse/sale/pit';
import { metaverseSaleOrder } from '@redux/metaverse/sale/order';

// 发行方公告
import { publicSaaSNotices } from '@redux/public/SaaSNotices';

// 统计分析-每日数据
import { statisticsSale } from '@redux/statistics/sale';

// 财务管理-经济系统
import { financeEconomicSysMetaMilletTransferRecord } from '@redux/finance/economicSys/metaMilletTransferRecord';
import { financeEconomicSysMetaMilletTransferRecordDetail } from '@redux/finance/economicSys/metaMilletTransferRecordDetail';
import { financeEconomicSysYaoExchangeDiamondRecord } from '@redux/finance/economicSys/yaoExchangeDiamondRecord';
import { financeEconomicSysYaoExchangeConfig } from '@redux/finance/economicSys/yaoExchangeConfig';
import { financeEconomicSysYaoExchangeRecord } from '@redux/finance/economicSys/yaoExchangeRecord';
import { financeEconomicSysYaoExchangeRecordDetail } from '@redux/finance/economicSys/yaoExchangeRecordDetail';
import { financeEconomicSysYaoMilletConfig } from '@redux/finance/economicSys/yaoMilletConfig';
import { financeEconomicSysYaoMilletOrder } from '@redux/finance/economicSys/yaoMilletOrder';
import { financeEconomicSysYaoMilletOrderDetail } from '@redux/finance/economicSys/yaoMilletOrderDetail';
import { financeEconomicSysYaoTaskConfig } from '@redux/finance/economicSys/yaoTaskConfig';
import { financeEconomicSysJoinRecord } from '@redux/finance/economicSys/joinRecord';
import { financeEconomicSysYaoLoginRule } from '@redux/finance/economicSys/yaoLoginRule';

// 业务管理-机构管理-首页空间数藏
import { NFTCollectionCompanyShow } from '@redux/NFT/collection/companyShow/companyShow';

// 业务管理-客户管理-用户地址
import { bizUserChainAddress } from '@redux/biz/user/chainAddress/chainAddress';

// 系统管理-广告位管理-资讯管理
import { systemHomeInformation } from '@redux/system/home/information';

// 元宇宙管理-直播会议
import { metaverseMeetingRoom } from '@redux/metaverse/meeting/room';
import { metaverseMeetingApplication } from '@redux/metaverse/meeting/application';
import { metaverseMeetingReserveRecord } from '@redux/metaverse/meeting/reserveRecord';
import { metaverseMeetingRecord } from '@redux/metaverse/meeting/record';

// 系统管理-咨询管理
import { systemInformation } from '@redux/system/information';

// 元宇宙管理-机器人挖宝
import { metaverseRobotActivity } from '@redux/metaverse/robot/activity';
import { metaverseRobotActivityAwardPool } from '@redux/metaverse/robot/activityAwardPool';
import { metaverseRobotCollectionConfig } from '@redux/metaverse/robot/collectionConfig';
import { metaverseRobotPoolConfig } from '@redux/metaverse/robot/poolConfig';

// 用户资产-白虎钥匙管理
import { NFTCollectionBaihuKey } from '@redux/NFT/collection/BaihuKey';

// 统计分析-资产库统计
import { statisticsCollectionLibrary } from '@redux/statistics/collectionLibrary';

// 业务管理-亨通系统
import { bizChannelHTUserEmpowerRecord } from '@redux/biz/channelHT/userEmpowerRecord';
import { bizChannelHTCompanyEmpowerRecord } from '@redux/biz/channelHT/companyEmpowerRecord';
import { bizChannelHTCollectionSeries } from '@redux/biz/channelHT/collectionSeries';
import { bizChannelHTExportOrder } from '@redux/biz/channelHT/exportOrder';

// 系统管理-广告位管理-亨通寄售入口Banner
import { systemHomeHTBanner } from '@redux/system/home/HTBanner';
import { NFTCollectionBuyOrderPFP } from '@redux/NFT/collection/buyOrderPFP';

// 寄售管理 -- 一口价管理 -- 交易日历配置
import { NFTTradingCalendar } from '@redux/NFT/order/calendar';

// 财务管理 -- 充值管理 -- 线下打款审核
import { financeRechargeOfflineQuery } from '@redux/finance/recharge/offlineQuery';

// 业务管理 -- 资产登记 -- 资产登记
import { bizAssetRegistrationList } from '@redux/biz/assetRegistration/list';
import { bizAssetRegistrationDetailRecord } from '@redux/biz/assetRegistration/detailRecord';

// 业务管理-权益管理-实物权益管理
import { NFTCollectionRightsManageReal } from '@redux/NFT/collection/rightsManageReal/rightsManageReal';
import { NFTCollectionRightsManageRealUseRecord } from '@redux/NFT/collection/rightsManageReal/useRecord';

// 统计管理-大户统计
import { statisticsLargecustomer } from '@redux/statistics/largecustomer';
// 统计管理-手续费日报表
import { statisticsFeeDailyReport } from '@redux/statistics/feeDailyReport';
import { statisticsFeeDailyReportDetail } from '@redux/statistics/feeDailyReportDetail';
// 统计管理-二级交易日报表
import { statisticsMarketDailyReport } from '@redux/statistics/marketDailyReport';

export default combineReducers({
  publicAboutus,
  user,
  menu,
  modalDetail,
  systemRole,
  systemMenu,
  systemUser,
  systemPwdReset,
  systemSysParam,
  systemUpdate,
  systemStrategy,
  systemLog,
  // 公告管理 - 公告编辑
  publicNotices,
  publicSystemNotices,
  publicHelpManual,
  publicHelpManualSend,
  publicTestAction,
  publicBanner,
  publicBannerUp,
  publicMessage,
  publicCompanyMessage,
  DataDict,
  MenuManagement,
  systemArticleClass,
  customerService,
  bizUserUser,
  bizUserUserCloseList,
  bizUserUserAddress,
  bizUserTransferRecord,
  bizUserTransferRecordDetail,
  bizUserPlatUser,
  bizUserLevel,
  bizUserLevelRules,
  bizUserKycCheck,
  bizActiveCodeActivityCode,
  bizFreeUser,
  bizUserDiamondRules,
  financeMemberAccount,
  financeMemberAccountBalance,
  financeMemberAccountDiamond,
  financeMemberAccountIntegral,
  financeMemberAccountEssence,
  financeMemberAccountBill,
  financeMemberAccountYao,
  financeWithdrawalApproval,
  financeWithdrawalRecord,
  financeWithdrawalRecordExportPaymentBill,
  financeWithdrawalCompleted,
  financeWithdrawalNopass,
  financeWithdrawalRejected,
  financeWithdrawalRelus,
  financeWithdrawalPayFail,
  financeWithdrawalPaying,
  financeWithdrawalInitiating,
  financeRechargeQuery,
  financeRechargeGJQuery,
  financeTransferApproval,
  financeTransferCompleted,
  financeTransferNopass,
  financeTransferRules,
  bizIncomeTeam,
  bizIncomeRules,
  bizIncomeDailyUser,
  bizIncomeIncome,
  bizIncomeConfig,
  financeMemberAccountSnapshot,
  systemVersionLog,
  statisticsDailyReport,
  // 业务管理 评论管理
  bizCommentKeywords,
  bizCommentCheck,
  bizCommentList,
  bizCommentReport,
  // 业务管理-帖子管理
  bizPostList,
  bizPostReport,
  // NFT管理-时刻管理
  NFTCollectionCollection,
  NFTCollectionModelList,
  NFTCollectionModel,
  NFTCollectionModelRecovery,
  NFTCollectionModelCirculatio,
  NFTCollectionCategory,
  NFTCollectionConfig,
  NFTCollectionTransferRecord,
  NFTCollectionTransferRecordCollection,
  // NFT管理-出售管理
  NFTOrderBidding,
  NFTOrderBiddingRecord,
  NFTOrderBiddingDelayRecord,
  NFTOrderBiddingBondRecord,
  NFTOrderBiddingConfig,
  NFTOrderBuyoutPrice,
  NFTOrderBuyoutPriceOrder,
  NFTOrderBuyoutPriceConfig,
  NFTOrderCollectionPack,
  NFTOrderCollectionPackOrder,
  NFTOrderCategory,
  NFTOrderHistoryBidding,
  NFTOrderHistoryBuyoutPrice,
  NFTOrderHistoryBuyoutPriceOrder,
  // NFT管理-挑战管理
  NFTChallengeList,
  NFTChallengeInProgress,
  NFTChallengeAwardProvide,
  NFTChallengeComponentCollection,
  NFTChallengeComponentAwardWinningRecord,
  NFTChallengeFail,
  NFTChallengeHistory,
  NFTChallengeChallenge,
  NFTChallengeChallengeCondition,
  NFTChallengeOrderNFT,
  NFTChallengeOrderReal,
  NFTChallengeCategory,
  publicDetailList,
  NFTOrderWorkConfig,
  NFTOrderPfpConfig,
  // NFT管理-导出管理
  NFTExportList,
  NFTExportListDetail,
  NFTExportBlockChainAddressM,
  NFTExportBeOnTheAir,
  NFTExportToBeBroadcast,
  NFTExportNopass,
  NFTExportSuccess,
  NFTExportFail,
  // NFT管理-铸币管理
  NFTContractTokenList,
  NFTContractTokenBlockChainAddressS,
  NFTContractTokenBlockChainAddressW,
  // NFT管理-导入管理
  NFTImportList,
  NFTImportAddress,
  // NFT管理-关注管理
  NFTFollowCollection,
  NFTFollowCollectionPack,
  // 时刻管理-百变大咖
  NFTChangeSeries,
  NFTChangeType,
  NFTChangeModule,
  NFTChangeRecommendModule,
  NFTChangeConfig,
  NFTChangeBuyOrder,
  NFTChangeModifyRecord,
  // 时刻管理-盲盒管理
  NFTBlindBoxBlindBoxModule,
  NFTBlindBoxBlindKnapsack,
  NFTBlindBoxConfig,
  NFTBlindBoxSeries,
  NFTBlindBoxBuyOrder,
  // 业务管理-宝藏计划
  bizTreasurePlan,
  bizTreasurePlanDetail,
  // 时刻管理-资产销售
  NFTCollectionWorks,
  NFTCollectionWorksPFP,
  NFTCollectionNoSale,
  NFTCollectionWorksDropRecord,
  NFTCollectionWorksDistribution,
  NFTCollectionCopyrightSale,
  NFTCollectionCopyrightUser,
  NFTCollectionBuyOrder,
  NFTCollectionBuyOrderPFP,
  NFTCollectionDerivativeSale,
  NFTCollectionAuthor,
  NFTCollectionAuthorEditRecord,
  NFTCollectionAuthorCollection,
  NFTCollectionAuthorChannel,
  NFTCollectionAuthorLoginConfig,
  NFTCollectionEntity,
  NFTCollectionBlindBoxSale,
  NFTCollectionLuckDrawSale,
  NFTCollectionLuckDrawSaleJoinRecord,
  NFTCollectionSetWord,
  NFTCollectionPfpPeriodSale,
  // 会员管理-渠道商管理
  bizUserChannelStore,
  // 会员管理-渠道管理
  bizUserChannelConfig,
  // 会员管理-推荐设置
  bizUserInviteConfig,
  // 会员管理-推荐分成
  bizUserIncomeRefer,
  // 机构管理-兑换码管理
  NFTCollectionExchangeCode,
  // 机构管理-期数兑换码管理
  NFTCollectionExchangeCodePeriod,
  // 机构管理-合约管理
  NFTCollectionContract,
  // 活动管理-活动管理
  NFTActivityActivity,
  NFTActivityCard,
  NFTActivityLotteryRecord,
  NFTActivityPrize,
  NFTActivitySynthesisRecord,
  NFTActivityRanking,
  // 统计分析-每日数据
  statisticsTradeDataDay,
  // 运维数据-业务支付渠道管理
  systemBusinessChannel,
  // 财务管理-银行管理
  financeBankInfo,
  // 财务管理-三方支付
  financeBankChannel,
  financeUserBindCard,
  // 三方系统
  bizChannelSystem,
  bizChannelTransferOrder,
  bizChannelTransferCollection,
  bizChannelSysSynchronize,
  bizChannelSysXmeta,
  bizChannelSysXmetaOrder,
  bizChannelSysXmetaExchange,
  // 竞拍管理
  NFTCollectionAuction,
  NFTCollectionAuctionRecord,
  NFTCollectionAuctionDelayRecord,
  NFTCollectionAuctionBondRecord,
  statisticsExcludeUserRecord,
  // 拉新活动
  InvitationActivity,
  InvitationActivitySeries,
  InvitationActivityUserRecord,
  InvitationActivitySum,
  // 统计分析-每日资产统计
  statisticsCollection,
  // 财务管理-三方结算管理
  settlementApply,
  settlementAccount,
  settlementAccountSettlementRecord,
  settlementAccountJour,
  // 赋能商城
  goodsCategory,
  goodsClass,
  goodsSupplier,
  goodsIntegral,
  goodsIntegralAdditional,
  goodsBuyRecord,
  goodsExchangeRecord,
  goodsExchangeRecordDetail,
  goodsJoinRecord,
  goodsActivityFinishRecord,
  goodsActivity,
  // 统计分析-元气超市统计
  statisticsGoods,
  // 元宇宙管理-兑换管理
  metaversePit,
  metaversePitSeller,
  metaversePitConditionsDetail,
  metaverseJoinRecord,
  metaverseJoinRecordCollection,
  // 客户管理-实名配置
  bizUserIdentifyConfig,
  // 通知管理-公告弹窗
  publicNoticesWindow,
  // 权益中心-降拍管理
  rightInterestCategory,
  rightInterestAuction,
  rightInterestAuctionOrder,
  rightInterestBidRecord,
  rightInterestBondRecord,
  rightInterestChangeRecord,
  // 营销管理-抽奖活动
  marketingLotteryActivity,
  marketingLotteryJoinOrder,
  marketingLotteryJoinRecord,
  marketingLotteryJoinDetail,
  // 业务管理-渠道商管理
  bizChannelMerchant,
  // 业务管理-机构管理-出品方管理
  NFTCollectionProduced,
  // 财务管理-发行方结算账户
  financeCompany,
  financeCompanySettleRecord,
  // 业务管理-机构管理-权益管理
  NFTCollectionRightsManage,
  NFTCollectionRightsManageUseRecord,
  NFTCollectionRightsManageAuthorRecord,
  // 财务管理-开票管理
  financeApplyInvoice,
  // 营销管理-芯片资产
  marketingChipActivity,
  marketingChipCollectionRecord,
  marketingChipUid,
  // 元宇宙管理-机器人管理
  metaverseRobotConfig,
  metaverseRobotAward,
  metaverseRobotCalculationRrecord,
  metaverseRobotWorkRecord,
  metaverseRobotWorkRobotRecord,
  metaverseRobotSysParam,
  // 期数审核
  periodCheckSellModifyCollectionList,
  periodCheckWordList,
  periodCheckDropList,
  periodCheckPriorityList,
  periodCheckDiscountList,
  // 系统管理-首页管理
  systemHomeBanner,
  systemHomeFunction,
  systemHomePlateCategory,
  systemHomeMyPageBtn,
  systemHomeBalancePageBtn,
  // 元宇宙管理-售卖管理
  metaverseSaleDerivative,
  metaverseSalePit,
  metaverseSaleOrder,
  // 发行方公告
  publicSaaSNotices,
  // 统计分析-每日数据
  statisticsSale,
  // 财务管理-经济系统
  financeEconomicSysMetaMilletTransferRecord,
  financeEconomicSysMetaMilletTransferRecordDetail,
  financeEconomicSysYaoExchangeDiamondRecord,
  financeEconomicSysYaoExchangeConfig,
  financeEconomicSysYaoExchangeRecord,
  financeEconomicSysYaoExchangeRecordDetail,
  financeEconomicSysYaoMilletConfig,
  financeEconomicSysYaoMilletOrder,
  financeEconomicSysYaoMilletOrderDetail,
  financeEconomicSysYaoTaskConfig,
  financeEconomicSysJoinRecord,
  financeEconomicSysYaoLoginRule,
  // 业务管理-机构管理-首页空间数藏
  NFTCollectionCompanyShow,
  // 业务管理-客户管理-用户地址
  bizUserChainAddress,
  // 系统管理-广告位管理-资讯管理
  systemHomeInformation,
  // 元宇宙管理-直播会议
  metaverseMeetingRoom,
  metaverseMeetingApplication,
  metaverseMeetingReserveRecord,
  metaverseMeetingRecord,
  // 系统管理-咨询管理
  systemInformation,
  // 元宇宙管理-机器人挖宝
  metaverseRobotActivity,
  metaverseRobotActivityAwardPool,
  metaverseRobotCollectionConfig,
  metaverseRobotPoolConfig,
  // 用户资产-白虎钥匙管理
  NFTCollectionBaihuKey,
  // 统计分析-资产库统计
  statisticsCollectionLibrary,
  // 业务管理-亨通系统
  bizChannelHTUserEmpowerRecord,
  bizChannelHTCompanyEmpowerRecord,
  bizChannelHTCollectionSeries,
  bizChannelHTExportOrder,
  // 系统管理-广告位管理-亨通寄售入口Banner
  systemHomeHTBanner,
  // 寄售管理 -- 一口价管理 -- 交易日历配置
  NFTTradingCalendar,
  // 财务管理 -- 充值管理 -- 线下打款审核
  financeRechargeOfflineQuery,
  // 业务管理 -- 资产登记 -- 资产登记
  bizAssetRegistrationList,
  bizAssetRegistrationDetailRecord,
  // 业务管理-权益管理-实物权益管理
  NFTCollectionRightsManageReal,
  NFTCollectionRightsManageRealUseRecord,

  // 统计管理-大户统计
  statisticsLargecustomer,
  // 统计管理-手续费日报表
  statisticsFeeDailyReport,
  statisticsFeeDailyReportDetail,
  // 统计管理-二级交易日报表
  statisticsMarketDailyReport
});
